import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4b5f77fa"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "trade_buttons" };
import Button from '@/materials/atoms/Button.vue';
import { ref } from 'vue';
import { useMessage } from '@/const/messages';
export default /*#__PURE__*/ _defineComponent({
    props: {
        trade: { default: 'Buy' }
    },
    emits: ["click"],
    setup(__props, { emit }) {
        const props = __props;
        const { format, ORDER } = useMessage();
        const selectValue = ref(props.trade);
        const onClick = (innerText) => {
            selectValue.value = innerText;
            emit('click', innerText);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Button, {
                    width: "50%",
                    height: "30px",
                    class: _normalizeClass(["margin trade_button long", selectValue.value === 'Buy' ? 'select' : 'no_select']),
                    innerText: _unref(format)(_unref(ORDER).BUY),
                    colorMode: "long",
                    onClick: _cache[0] || (_cache[0] = ($event) => (onClick('Buy')))
                }, null, 8, ["class", "innerText"]),
                _createVNode(Button, {
                    width: "50%",
                    height: "30px",
                    class: _normalizeClass(["trade_button short", selectValue.value === 'Sell' ? 'select' : 'no_select']),
                    innerText: _unref(format)(_unref(ORDER).SELL),
                    colorMode: "short",
                    onClick: _cache[1] || (_cache[1] = ($event) => (onClick('Sell')))
                }, null, 8, ["class", "innerText"])
            ]));
        };
    }
});
